import TopBar from "../../common/TopBar"
import PrivacyPolicyContents from "../../common/PrivacyPolicyContents";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function PrivacyPolicy() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const topHeader = {
    title: t('privacy.title'),
    leftIcon: "/images/totp/ui/left.png",
  }

  const handleGoToList = () => {
    navigate('/vtotp/otp-list');
  };

  return (
    <div className="page-wrapper">
      <TopBar topHeader={topHeader} onLeftClick={handleGoToList}/>
      <PrivacyPolicyContents/>
    </div>
  )
}